import Vue from "vue";
import features from "../features.json";

const CURRENT_TARGET = process.features.target || ["dev"];

const feature = new Vue({
  computed: {
    currentTarget() {
      return CURRENT_TARGET;
    },
    isAudiTarget() {
      return CURRENT_TARGET.includes("audi");
    },
    isDBTarget() {
      return CURRENT_TARGET.includes("deutscheBahn");
    },
    isPorscheTarget() {
      return CURRENT_TARGET.includes("porsche");
    },
    isMSMGermanyTarget() {
      if (CURRENT_TARGET.includes("dev") || CURRENT_TARGET.includes("prod") || CURRENT_TARGET.includes("training")) return true;
      else return false;
    },
  },
  methods: {
    isEnabled(name) {
      if (!features[name] || !features[name].target) {
        console.error("Unknown feature: " + name);
        return false;
      }

      let targets = features[name].target.split(" ");
      if (targets.indexOf(CURRENT_TARGET) > -1) return true;
      return false;
    },
    isDisabled(name) {
      return !this.isEnabled(name);
    },
  },
});

export default feature;



// WEBPACK FOOTER //
// ./src/feature.js